registerComponent("sections/pj-conta", function (component) {
/**
 * Conta PJ — sem comportamento próprio.
 *
 * A entrada escalonada dos cartões, do cabeçalho e do cartão do app é do
 * `sections/produtos`, que observa `.card`, `.produtos__app` e
 * `.produtos__midia` dentro de cada `.produtos__painel`. A pilha `sticky` e o
 * scroll-spy do submenu também são de lá.
 */

});
